var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMasterCoverOnDisplay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 229,
    height: 93,
    viewBox: "0 0 229 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148058",
    "data-name": "Rectangle 148058",
    width: 229,
    height: 93,
    rx: 10,
    transform: "translate(0)",
    fill: "#f2bbab"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148080",
    "data-name": "Rectangle 148080",
    width: 228.996,
    height: 426.834,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Master_Cover_On_Display",
    "data-name": "Master Cover On Display",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Master_BG",
    "data-name": "Master BG",
    transform: "translate(0 -152.469)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148079",
    "data-name": "Rectangle 148079",
    width: 228.996,
    height: 426.834,
    transform: "translate(0.002)",
    fill: "#f686a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6109",
    "data-name": "Path 6109",
    d: "M169.5,29.09a33.289,33.289,0,0,0-4.712-.458c-23.851-.618-65.878,31.272-45.855,68.45,4.512,8.378,12.009,13.544,15.958,22.4,5.255,11.789,2.042,28.745-6.8,35.922-10.273,8.333-23.548,3.175-35.54,4.97-13.874,2.077-26.559,14.61-31.934,31.549s-3.222,37.6,5.419,52.023c12.941,21.592,36.293,26.217,57.2,25.828,16.364-.3,34.036-3.514,46.265-17.325Z",
    transform: "translate(59.495 77.615)",
    fill: "#ffaec9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6110",
    "data-name": "Path 6110",
    d: "M105.751,132.951c-10.479-8.771-22.243-16.007-29.695-29.076A27.632,27.632,0,0,1,72,90.763C71.848,80.489,79.18,73.2,83.533,64.671,95.82,40.579,84.553,14.423,64.68,11.811c-15.97-2.1-32.838,2.426-48.488,10.5V178.4c6.221-4.775,10.8-14.069,17.86-16.7,9.41-3.505,18.7,6.325,24.165,16.991s9.442,23.316,17.528,30.546c9.626,8.607,22.945,7.023,33.221-.171,10.821-7.573,19.574-22.511,18.568-38.568C126.513,154.229,116.231,141.722,105.751,132.951Z",
    transform: "translate(-16.19 30.637)",
    fill: "#ffaec9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_162886",
    "data-name": "Group 162886",
    transform: "translate(0.002)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6111",
    "data-name": "Path 6111",
    d: "M245.327,95.9c-32.274,1-64.376,15.563-89.64,42.057-12.761,13.38-24.172,29.814-39.259,38.006A43.092,43.092,0,0,1,87.309,180.6c-9.172-1.829-18.724-7.73-22.428-18.909-8.253-24.9,17.354-52.849,9.522-77.986C70.99,72.746,61.623,66.317,52.615,66.418S35.075,72.171,28.1,79.665a78.832,78.832,0,0,0-11.774,16.7V247.421h229Z",
    transform: "translate(-15.942 180.095)",
    fill: "#d1005f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6112",
    "data-name": "Path 6112",
    d: "M245.189,95.713c-32.274,1-64.376,15.563-89.64,42.057-12.761,13.38-24.172,29.814-39.259,38.006a43.092,43.092,0,0,1-29.119,4.638C78,178.584,68.448,172.682,64.743,161.5,56.491,136.6,82.1,108.655,74.265,83.518c-3.413-10.956-12.78-17.384-21.788-17.284S34.938,71.987,27.965,79.481a78.831,78.831,0,0,0-11.774,16.7V247.237h229Z",
    transform: "translate(-16.193 179.597)",
    fill: "#ff5595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6113",
    "data-name": "Path 6113",
    d: "M67.04,45.192c6.9,3.88,13.941,12.183,12.423,21.846-.665,4.232-2.885,7.725-5.2,10.8A74.906,74.906,0,0,1,59.551,92.715c-5.009,3.77-10.809,7.291-13.021,14.3-2.264,7.174.336,15.826,4.878,20.794s10.588,6.876,16.472,7.6c13.408,1.652,27.181-2.192,38.916-10.868,11.068-8.18,20.714-20.7,33.16-24,18.069-4.8,36.782,11.179,54.53,11.35V.184H47.317C38.175,26.105,50.5,35.9,67.04,45.192Z",
    transform: "translate(34.898 0.498)",
    fill: "#d1005f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6114",
    "data-name": "Path 6114",
    d: "M66.9,45.009c6.9,3.88,13.941,12.183,12.423,21.846-.665,4.232-2.885,7.725-5.2,10.8A74.908,74.908,0,0,1,59.413,92.532C54.4,96.3,48.6,99.823,46.392,106.831c-2.264,7.174.336,15.826,4.878,20.794s10.588,6.876,16.472,7.6c13.408,1.653,27.181-2.192,38.916-10.868,11.068-8.18,20.714-20.7,33.16-24,18.069-4.8,36.782,11.179,54.53,11.35V0H47.179C38.037,25.921,50.367,35.713,66.9,45.009Z",
    transform: "translate(34.647)",
    fill: "#ff5595"
  })), /*#__PURE__*/React.createElement("text", {
    id: "SIFU",
    transform: "translate(105.023 184.944)",
    fill: "none",
    stroke: "#231f20",
    strokeWidth: 0.166,
    fontSize: 11,
    fontFamily: "'Bauhaus \\\\\\\\39 3'"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SIFU")), /*#__PURE__*/React.createElement("text", {
    id: "MASTER",
    transform: "translate(82.188 207.661)",
    fill: "#fff",
    fontSize: 18,
    fontFamily: "'Bauhaus \\\\\\\\39 3'"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "MASTER")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148081",
    "data-name": "Rectangle 148081",
    width: 79.318,
    height: 60.027,
    transform: "translate(74.841 167.081)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.046
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_162887",
    "data-name": "Group 162887",
    transform: "translate(32.32 82.376)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6115",
    "data-name": "Path 6115",
    d: "M78.565,52.069,55.221,102.357l-39.655-21.4L38.911,30.668Z",
    transform: "translate(-3.929 0.784)",
    fill: "#e2a817"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6116",
    "data-name": "Path 6116",
    d: "M23.082,103.934,11.445,72.483,34.79,22.194,46.427,53.646Z",
    transform: "translate(-11.445 -22.194)",
    fill: "#ff7926"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6117",
    "data-name": "Path 6117",
    d: "M31.35,53.646,19.712,22.194l39.654,21.4L71,75.047Z",
    transform: "translate(3.633 -22.194)",
    fill: "#fdcb30"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6118",
    "data-name": "Path 6118",
    d: "M83.569,50.212,60.224,100.5,20.569,79.1,43.915,28.811Z",
    transform: "translate(37.516 78.124)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.019
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6119",
    "data-name": "Path 6119",
    d: "M28.085,102.077,16.448,70.626,39.793,20.337,51.431,51.789Z",
    transform: "translate(30 55.146)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.019
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6120",
    "data-name": "Path 6120",
    d: "M36.353,51.789,24.716,20.337l39.655,21.4L76.007,73.19Z",
    transform: "translate(45.078 55.146)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.019
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_162888",
    "data-name": "Group 162888",
    transform: "translate(29.3 231.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6121",
    "data-name": "Path 6121",
    d: "M48.831,64.205l11.477,45.572L29.292,130.9,17.814,85.324Z",
    transform: "translate(3.191 -57.139)",
    fill: "#e2a817"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6122",
    "data-name": "Path 6122",
    d: "M42.858,120.63l-21.005-7.067L10.376,67.991l21,7.067Z",
    transform: "translate(-10.376 -46.874)",
    fill: "#ff7926"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6123",
    "data-name": "Path 6123",
    d: "M31.38,90.486l-21-7.067L41.391,62.3,62.4,69.368Z",
    transform: "translate(-10.376 -62.301)",
    fill: "#fdcb30"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6124",
    "data-name": "Path 6124",
    d: "M50.313,60.117,61.79,105.689,30.774,126.807,19.3,81.235Z",
    transform: "translate(35.194 163.013)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.016
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6125",
    "data-name": "Path 6125",
    d: "M44.34,116.542l-21-7.067L11.858,63.9l21,7.067Z",
    transform: "translate(21.628 173.279)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.016
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6126",
    "data-name": "Path 6126",
    d: "M32.863,86.4l-21-7.067L42.874,58.213l21,7.067Z",
    transform: "translate(21.628 157.85)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.016
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_162889",
    "data-name": "Group 162889",
    transform: "translate(151.331 205.823)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6127",
    "data-name": "Path 6127",
    d: "M77.421,57.622l1.41,27.992-19.9,5.969L57.52,63.591Z",
    transform: "translate(-46.426 -49.576)",
    fill: "#e2a817"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6128",
    "data-name": "Path 6128",
    d: "M66.095,93.1,55,85.054,53.591,57.062l11.094,8.045Z",
    transform: "translate(-53.591 -51.093)",
    fill: "#ff7926"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6129",
    "data-name": "Path 6129",
    d: "M64.685,69.469,53.591,61.424l19.9-5.97L84.586,63.5Z",
    transform: "translate(-53.591 -55.454)",
    fill: "#fdcb30"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6130",
    "data-name": "Path 6130",
    d: "M83.694,51.66,85.1,79.652,65.2,85.621,63.792,57.629Z",
    transform: "translate(116.345 140.082)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.009
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6131",
    "data-name": "Path 6131",
    d: "M72.367,87.138,61.273,79.093,59.864,51.1l11.094,8.045Z",
    transform: "translate(109.18 138.565)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.009
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6132",
    "data-name": "Path 6132",
    d: "M70.958,63.507,59.864,55.462l19.9-5.97,11.094,8.046Z",
    transform: "translate(109.18 134.204)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.009
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6133",
    "data-name": "Path 6133",
    d: "M96.259,60.54,77.753,36.217,60.037,59.5l-8.372-11,26.088-34.29L104.63,49.537Z",
    transform: "translate(94.228 38.53)",
    fill: "#3b00a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6134",
    "data-name": "Path 6134",
    d: "M96.259,69.008,77.753,44.685,60.037,67.972l-8.372-11,26.088-34.29L104.63,58Z",
    transform: "translate(94.228 61.492)",
    fill: "#3b00a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6135",
    "data-name": "Path 6135",
    d: "M38.627,94.32,26.836,78.82,15.547,93.658l-5.334-7.012L26.836,64.8,43.962,87.308Z",
    transform: "translate(18.628 175.704)",
    fill: "#3b00a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6136",
    "data-name": "Path 6136",
    d: "M38.627,99.715l-11.792-15.5L15.547,99.054l-5.334-7.012L26.836,70.193,43.962,92.7Z",
    transform: "translate(18.628 190.336)",
    fill: "#3b00a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6137",
    "data-name": "Path 6137",
    d: "M67.632,114.527l-7.578-9.961L52.8,114.1,49.371,109.6,60.054,95.554l11.007,14.467Z",
    transform: "translate(90.043 259.105)",
    fill: "#3b00a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6138",
    "data-name": "Path 6138",
    d: "M67.632,117.995l-7.578-9.961L52.8,117.57l-3.428-4.506L60.054,99.022l11.007,14.467Z",
    transform: "translate(90.043 268.508)",
    fill: "#3b00a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6139",
    "data-name": "Path 6139",
    d: "M89.095,41.424l-5.319,7.221c-1.615,2.192.932,5.547,2.549,3.351l5.319-7.221C93.259,42.583,90.713,39.232,89.095,41.424Z",
    transform: "translate(106.126 110.389)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6140",
    "data-name": "Path 6140",
    d: "M90.978,48.787l-5.319,7.221c-1.615,2.192.932,5.547,2.549,3.351l5.319-7.221C95.143,49.946,92.6,46.591,90.978,48.787Z",
    transform: "translate(109.562 130.349)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6141",
    "data-name": "Path 6141",
    d: "M89.22,45.455l-4.83,6.288c-1.651,2.15.9,5.5,2.549,3.351l4.83-6.289c1.651-2.149-.9-5.5-2.549-3.35Z",
    transform: "translate(107.212 121.378)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6142",
    "data-name": "Path 6142",
    d: "M95.088,47.922l-4.83,6.288c-1.651,2.15.9,5.5,2.549,3.351l4.83-6.288C99.287,49.124,96.739,45.773,95.088,47.922Z",
    transform: "translate(117.914 128.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6143",
    "data-name": "Path 6143",
    d: "M85.48,41.407,80.649,47.7c-1.651,2.15.9,5.5,2.549,3.351l4.83-6.288C89.679,42.61,87.13,39.259,85.48,41.407Z",
    transform: "translate(100.391 110.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6144",
    "data-name": "Path 6144",
    d: "M93.08,40.166l-4.83,6.288c-1.651,2.15.9,5.5,2.549,3.351l4.83-6.288C97.281,41.367,94.731,38.017,93.08,40.166Z",
    transform: "translate(114.254 107.038)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6145",
    "data-name": "Path 6145",
    d: "M85.48,46.3l-4.83,6.288c-1.651,2.149.9,5.5,2.549,3.35l4.83-6.288C89.679,47.5,87.13,44.152,85.48,46.3Z",
    transform: "translate(100.391 123.675)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6146",
    "data-name": "Path 6146",
    d: "M93.377,44.607,88.547,50.9c-1.651,2.149.9,5.5,2.549,3.351l4.83-6.288C97.577,45.809,95.028,42.458,93.377,44.607Z",
    transform: "translate(114.794 119.081)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6147",
    "data-name": "Path 6147",
    d: "M102.128,122.185a3.2,3.2,0,0,1-1.008-3.692c3.615-10.076.32-22.14-7.345-26.893s-16.844-.421-20.46,9.655c-.5,1.386-1.755,1.979-2.809,1.326A3.2,3.2,0,0,1,69.5,98.889C74.1,86.046,85.8,80.525,95.576,86.583s13.971,21.434,9.362,34.278C104.44,122.246,103.182,122.839,102.128,122.185Z",
    transform: "translate(80.659 228.11)",
    fill: "#d1005f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6148",
    "data-name": "Path 6148",
    d: "M49.291,47.023c-.246,1.337-1.269,2.159-2.287,1.837-7.4-2.346-14.868,3.656-16.652,13.38s2.782,19.542,10.18,21.888a2.609,2.609,0,0,1,1.4,3c-.245,1.337-1.269,2.159-2.286,1.837-9.429-2.99-15.249-15.505-12.974-27.9s11.8-20.044,21.225-17.054A2.609,2.609,0,0,1,49.291,47.023Z",
    transform: "translate(2.02 117.603)",
    fill: "#d1005f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6149",
    "data-name": "Path 6149",
    d: "M109.044,40.93c-1.232-.341-2.021-1.929-1.763-3.549,1.881-11.793-3.892-23.395-12.865-25.863s-17.8,5.116-19.676,16.911c-.258,1.622-1.468,2.661-2.7,2.321S70.014,28.82,70.273,27.2C72.663,12.167,83.913,2.5,95.345,5.644s18.791,17.933,16.4,32.964c-.258,1.62-1.466,2.659-2.7,2.322Z",
    transform: "translate(82.352 13.695)",
    fill: "#d1005f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6150",
    "data-name": "Path 6150",
    d: "M48.49,88.99a1.143,1.143,0,0,1,1.866.384c3.162,5.7,9.26,6.948,13.593,2.792S69.234,80,66.072,74.3a2.135,2.135,0,0,1,.291-2.453,1.144,1.144,0,0,1,1.866.383C72.259,79.49,71.045,89.7,65.522,95S52.228,98.7,48.2,91.444A2.137,2.137,0,0,1,48.49,88.99Z",
    transform: "translate(41.714 193.906)",
    fill: "#d1005f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6151",
    "data-name": "Path 6151",
    d: "M77.758,0A35.553,35.553,0,0,1,65.944,15.519a56.846,56.846,0,0,1-8.433,4.624c-5.432,2.591-11.051,5.273-15.091,11.15-6.747,9.825-6.223,24.6-5.242,34.864.125,1.3.259,2.6.389,3.914,1.013,9.948,2.061,20.234-.722,29.135a22.825,22.825,0,0,1-12.7,14.543,17.191,17.191,0,0,1-7.958,1.327v4.769c.4.026.791.052,1.19.052a20.387,20.387,0,0,0,7.86-1.631c6.976-2.908,12.422-9.2,14.941-17.26,3.148-10.073,2.036-21,.959-31.564-.13-1.3-.263-2.591-.389-3.876-.893-9.337-1.414-22.718,4.341-31.1,3.438-5.006,8.4-7.372,13.648-9.877a59.184,59.184,0,0,0,8.908-4.9c6.079-4.322,10.975-11.04,14-19.21.057-.155.1-.321.152-.477Z",
    transform: "translate(-16.191)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6152",
    "data-name": "Path 6152",
    d: "M127.694,65.843V60.71c-9.094,4.54-15.554,15.1-15.972,26.526-.324,8.915,2.74,17.044,5.709,24.908a98.733,98.733,0,0,1,4.652,14.554c2.984,14.472-.577,32.021-9.082,44.712-3.532,5.27-8.174,9.328-12.664,13.254-7.107,6.213-14.456,12.638-17.856,24.08-6.108,20.549,4.17,41.775,10.841,52.6.184.3.367.579.551.871h4.744q-1.251-1.842-2.494-3.854c-6.177-10.021-15.728-29.567-10.282-47.888,2.984-10.048,9.547-15.786,16.493-21.858,4.685-4.093,9.528-8.331,13.375-14.069,9.282-13.853,13.151-33.118,9.855-49.083a102.657,102.657,0,0,0-4.9-15.42c-2.89-7.658-5.617-14.891-5.337-22.575C115.648,78.593,120.68,70.028,127.694,65.843Z",
    transform: "translate(101.304 164.622)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCoverOnDisplay);
export default __webpack_public_path__ + "static/media/Master Cover On Display.265f3a42370df6a5d5b7b24d83fab8a9.svg";
export { ForwardRef as ReactComponent };